// extracted by mini-css-extract-plugin
export var closed = "_91-1";
export var resizer = "_91-0";